<template>
    <div>
        <card-header title="Register My Conference (RMC)" icon="fa-presentation"/>

        <card-toolbar>
<!--            <button @click="$openCard('rmc-new-conference', {}, card)"><i class="far fa-plus"></i>New Conference</button>-->
        </card-toolbar>

        <card-body>
            <card-list>
                <search-list-item/>
                <subheader-list-item title="Conferences" icon="fa-presentation"/>
                <rmc-conf-tile
                        v-for="conf in conferences"
                        :card="card"
                        :conf="conf"
                        :active="(child && child.definition.component === 'rmc-conference' && conf.id === parseInt(child.props.confId))"
                        @click="$openCard('rmc-conference', {confId: conf.id}, card)"
                />
            </card-list>
        </card-body>

        <card-footer>
            <strong>Total Conferences:</strong> {{conferences.length}}
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import RmcConfTile from "@/components/rmc/RmcConfTile";

    import {client as http} from '../../http_client';

    export default {
        props: ['card', 'child'],
        components: {CardFooter, CardToolbar, RmcConfTile, CardHeader, CardBody, CardList, SearchListItem, SubheaderListItem},
        data() {
            return {
                conferences: []
            };
        },
        methods: {
            loadConferences: function(force) {
                this.$emit('loading', true);
                http.get('rmc/conferences/', {force}).then(response => {
                    this.conferences = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.loadConferences(true);
            }
        },
        mounted: function() {
            this.loadConferences();
        }
    };
</script>
